import React, { useEffect, useState } from 'react';
import CrudTable from '../table/crudtable'
import { exportDocumentConfigurationService, customerService } from '../../_services'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import { Modal, Button, Form } from 'react-bootstrap'
import { history } from '../../_helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlask } from '@fortawesome/free-solid-svg-icons'
import TestConfiguration from './testconfiguration'
import CopyConfiguration from './copyconfiguration'

function ExportDocumentConfigurationList() {

	const [customerCounts, setCustomerCounts] = useState(null)
	const [customers, setCustomers] = useState([])
	const [filteredCustomers, setFilteredCustomers] = useState([])
	const [showCustomerModal, setShowCustomerModal] = useState(false)
	const {t} = useTranslation('common')

	useEffect(() => {
        exportDocumentConfigurationService.getCustomerCounts().then(data => {
			setCustomerCounts(data)
        })
        customerService.list().then(data => {
			setCustomers(data)
		})
    }, []);

	const initialState = {
		name: '',
		description: '',
		type: 'POWERPOINT',
		nodes: []
	}

    const onAddClick = (row) => {
	    console.log('onAddClick')
		history.push("/exportDocumentConfiguration/create")
    }

    const onEditClick = (row) => {
	    console.log('onEditClick')
		history.push("/exportDocumentConfiguration/" + row.id)
    }

    const onCustomerCountClick = (e, row) => {
        e.preventDefault()

		var filteredCustomers = customers.filter(customer => {
			return customer.exportDocumentConfigurations.some(exportDocumentConfiguration => {
				return exportDocumentConfiguration.id == row.id
			})
		})
		setFilteredCustomers(filteredCustomers)
		setShowCustomerModal(true)
    }

	const columns = [
		{
			dataField: 'name',
			text: t('exportdocumentconfiguration.columns.name'),
			formatter: (cell, row) => <a href={'exportDocumentConfiguration/details/' + row.id}>{cell}</a>,
			sort: true
		},
		{
			dataField: 'description',
			text: t('exportdocumentconfiguration.columns.description'),
			formatter: cell => cell || '-',
			sort: true
		},
		{
			dataField: 'type',
			text: t('exportdocumentconfiguration.columns.type'),
			sort: true
		},
		{
			dataField: 'customers',
			text: t('exportdocumentconfiguration.columns.customers'),
			formatter: (cell, row) => {
				if (customerCounts[row.id]) {
					return <a href="#" onClick={e => onCustomerCountClick(e, row)}>
						{customerCounts[row.id]}
					</a>
				}
				return customerCounts[row.id]
			}
		},
		{
			dataField: 'id',
			text: '',
			style: {
		        width: '85px'
		    },
			formatter: (cell, row) => {
				return <span>
					<TestConfiguration configuration={row}/>
					<span>&nbsp;&nbsp;</span>
					<CopyConfiguration configuration={row}/>
				</span>
			}
		}
	]

	return (
		<div>
			<h2>
				{t('exportdocumentconfiguration.label')}
			</h2>
			{ customerCounts &&
				<CrudTable
					service={exportDocumentConfigurationService}
					columns={columns}
					initialState={initialState}
					//form={<ExportDocumentConfigurationForm />}
					sort={{dataField: 'name', order: 'asc'}}
					modalSize="lg"
					onAddClick={onAddClick}
					onEditClick={onEditClick}
					urlParams={true}
				/>
			}
			<Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showCustomerModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={e => setShowCustomerModal(false)}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('exportdocumentconfiguration.columns.customers')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<ul>
						{ filteredCustomers.map(customer => {
							return <li key={customer.id}>
								{customer.name}
							</li>
						})}
					</ul>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={e => setShowCustomerModal(false)}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default ExportDocumentConfigurationList;